/**
 * Noviqo Wishlist
 * Lightweight, client-side wishlist stored in localStorage.
 * No external app or backend required. Works per-browser/per-device.
 */
(function () {
  var STORAGE_KEY = 'noviqo_wishlist';

  function safeParse(json) {
    try {
      var parsed = JSON.parse(json);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function getWishlist() {
    try {
      return safeParse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode, etc.) — fail silently */
    }
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function toggleWishlist(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.push(handle);
    } else {
      list.splice(index, 1);
    }
    saveWishlist(list);
    updateAllButtons();
    updateCountBadge();
    return index === -1;
  }

  function updateButtonState(button) {
    var handle = button.getAttribute('data-product-handle');
    var active = isInWishlist(handle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active
      ? (window.noviqoWishlistStrings && window.noviqoWishlistStrings.remove) || 'Remove from wishlist'
      : (window.noviqoWishlistStrings && window.noviqoWishlistStrings.add) || 'Add to wishlist';
    button.setAttribute('aria-label', label);
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-noviqo-wishlist-toggle]').forEach(updateButtonState);
  }

  function updateCountBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('.noviqo-wishlist-count').forEach(function (badge) {
      var span = badge.querySelector('span[aria-hidden]');
      if (span) span.textContent = count;
      badge.hidden = count === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-noviqo-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    toggleWishlist(button.getAttribute('data-product-handle'));
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateAllButtons();
    updateCountBadge();
  });

  // Expose a small API for custom pages (e.g. the wishlist page template).
  window.NoviqoWishlist = {
    get: getWishlist,
    has: isInWishlist,
    toggle: toggleWishlist,
  };
})();
